export const performanceEs = {
  performanceNew: {
    to: "a",
    Last7days: "Los últimos 7 días",
    AttendanceStatus: "Estado de asistencia",
    AttendanceTime: "Tiempo de asistencia",
    quicklink: "quick link",
    OPlog: "OP log",
    precomplete: "pre-complete",
    inbound: "inbound",
    bound: "bound",
    APIcall: "API call",
    softphonecall: "softphone call",
    stopCollection: "Cese de la recaudación",
    cancelStopCollection: "Para cancelar una llamada de parada",
    selectDate: "Seleccione la fecha",
    isSureCancel: "Si se cancela la llamada de parada?"
  },
  warningLetter: {
    warningletters: 'Lista de cartas de advertencia',
    Download: 'Descargar',
    notDownloaded: "No descargado",
    alreadyDownloaded: 'Ha sido descargado',
    alreadySended: 'Ha sido enviado',
    sendSuccessfully: 'Enviado con éxito',
    pleaseDownloadFirstly: 'Por favor descargue primero',
  },
  urgeLetter: {
    urgeletter: 'Collection letter',
    Download: 'Download',
    selectUrgeLetter: 'Please select template',
  },
  relation: {
    companyPhone: "teléfono del trabajo",
    person2: "Contacto 2",
    person3: "Contacto 3",
    self: "Yo",
    role: "Rol",
    person1: "Contacto 1",
    DispalyNum: "Número principal ",
    DestNum: "Número de destino",
    BillID: "ID del costo",
    Direction: "Dirección de la llamada",
    IsnotConnect: "Contesta /No contesta ",
    OnboardTime: "Fecha de ingreso",
    WAContext: "Enviar contenido(WA)",
    WaitingDuration: "Tiempo de espera"
  },
  CallRecordQuery: {
    RecordingMethod: "Método de grabación ",
    RecordingFile: "Grabación ",
    Supplier: "Proveedor"
  },
  RiskReport: {
    RiskReport: "Reporta el riesgo",
    Risk: "riesgo"
  },
  CommonParam: {
    ParameterName: "Nombre de parámetro",
    ParameterDescription: "Descripción de parámetro",
    OperatingTime: "Tiempo de funcionamiento",
    Operator: "Operador",
    ParameterValue: "Valor de parámetro"
  },
  salaryReport: {
    timelimit: "límite de tiempo",
    whetherthenewstaffofthemonth: "Si es el nuevo ingreso del mes",
    basesalary: "salario base",
    isthefirstofthestaffIDnumber5: "El ID de empleado si empieza con 5",
    basicdailywage: "salario diario",
    actualbasicsalary: "sueldo f‌inal",
    staffcreatetime: "tiempo de creación del empleado",
    CurrentCycle: "Este periodo",
    LastCycle: "el periodo pasado",
    CurrentMonth: "este mes",
    Wagetimerange: "Rango de tiempo de salario"
  },
  applicationReview: {
    ApplyReason: "aplicar motivo",
    ApproveOpinion: "opinión de supervisión",
    Approve: "Aprobador",
    Passed: "Aprobar",
    Refused: "Aprobar Rechazar",
    Failed: "Deducir falla",
    Successful: "Deducir éxito",
    ApproveRemark: "comentario de supervicion",
    Detailsofexemption: "Detalles de la exención",
    IsRepay: "Pagado",
    Invalid: "Inválido",
    completeTicket: 'Completado'
  },
  OrderStatus: {
    PartiallyCompleted: 'Parcialmente completada',
    PrecompleteStatus: 'Estado de finalización del prepago',
    beyondCompareSubmitFailed: 'Superar la cantidad deducible, la presentación falló',
    manuoverdueDays: 'Se ha iniciado la escalada del caso, los resultados se sincronizarán con el chat grupal después de 10 minutos.',
    manuoverdueDaysFailed: 'Actualización fallida, inténtelo de nuevo'
  }
  // "First login time today": "Primer tiempo de inicio de sesión hoy",
  // "login time": "Tiempo de registro",
  // "Last update time": "Tiempo desde la última actualización",
  // 'Assign Num': "Nuevo número asignado",
  // 'KPI repay amount': "Objetivo de recuperación de pagos",
  // 'Group KPI repay amount': "Objetivo del equipo para recuperación de pagos",
  // "Half a month": "Mitad de mes",
  // "That day": "Ese día",
  // "Target amount of returns": "cantidad meta de devoluciones",
  // "Tiempo de PTP is incorrect, please fill in again": "Tiempo de PTP es incorrecto, por favor complete nuevamente",
};
